module.exports = __webpack_public_path__ + "static/media/RKrause_Lehrer.66324a42.JPG";